/* ct-price-theatre-1028 — el contador de la tienda, en 3 etapas. Vive DENTRO del contador nativo.
 *
 * Dictado de Amo (2026-07-06 · corregido 2026-07-08 · ampliado 2026-07-26):
 *   Etapa 1 — 10 s : la página abre con el precio MÁS ALTO. Al llegar a 0 el precio CAE al real,
 *                    y el número se pone ROJO un instante ANTES de cambiar (efecto aprobado por Amo).
 *   Etapa 2 — 30 min: "la oferta acaba en…".
 *   Etapa 3 — días : pasados los 30 min la oferta NO acaba: pasa a "oferta ampliada" y cuenta días.
 *   ⛔ NO se añade un segundo contador: es el NATIVO, uno solo, con su look.
 *
 * El inflado está anclado a TODO lo que mueve el precio (pack, variante, regalo, upsell) y aguanta
 * que el cliente cambie de uno a otro dentro de la etapa 1: un MutationObserver reaplica el inflado
 * sobre el valor NUEVO cada vez que el tema reescribe un precio.
 *
 * ⚠️ EL BUG DEL SEGUNDERO (Amo lo vio, 2026-07-26): el contador NATIVO tiene su propio setInterval y
 * repintaba los mismos <b> que pintábamos aquí → dos motores peleando por el mismo número, que
 * saltaba y parpadeaba. Arreglo: el motor nativo se neutraliza desde el liquid (se marca
 * cd1028Init ANTES de que arranque) y este script es el ÚNICO que pinta el reloj, en las 3 etapas.
 */
(function () {
  'use strict';

  var SEG_ETAPA1 = 10;          // Amo 2026-08-24: bajado de 28 a 10 segundos
  var MIN_ETAPA2 = 30;          // Amo 2026-07-26: subido de 28 a 30 minutos
  var DIAS_ETAPA3 = 3;          // etapa 3, en días
  var K = 'ct1028:teatro:v2';

  function sobreprecio(v) { return v < 50 ? 4 : (v < 100 ? 8 : 25); }

  var SEL_VIVO = [
    '.price__sale .price-item--sale',
    '.price__regular .price-item--regular',
    '.total-price',
    '.upsell1028__price strong',
    '.sticky-atc__price', '[class*="sticky"] .price-item--sale'
  ].join(',');
  var SEL_EXCLUIR = 's, del, strike, .qb1028__compare, .price__compare';

  function partes(txt) {
    var m = txt.match(/([^\d\s]*)\s*([\d.,\s]+)\s*([^\d\s]*)/);
    if (!m) return null;
    var pre = m[1] || '', num = m[2].replace(/\s/g, ''), post = m[3] || '';
    var coma = num.lastIndexOf(','), punto = num.lastIndexOf('.');
    var limpio = coma > punto ? num.replace(/\./g, '').replace(',', '.') : num.replace(/,/g, '');
    var val = parseFloat(limpio);
    if (isNaN(val)) return null;
    return { pre: pre, post: post, val: val, europeo: coma > punto };
  }

  function formatea(p, val) {
    var s = val.toFixed(2), t = s.split('.');
    var ent = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, p.europeo ? '.' : ',');
    return p.pre + ent + (p.europeo ? ',' : '.') + t[1] + p.post;
  }

  var etapa = 1, aplicando = false, obs = null;

  function inflar() {
    if (etapa !== 1 || aplicando) return;
    aplicando = true;
    document.querySelectorAll(SEL_VIVO).forEach(function (el) {
      if (el.closest(SEL_EXCLUIR)) return;
      var txt = el.textContent.trim();
      if (!txt || el.dataset.ctInflado === txt) return;
      var p = partes(txt);
      if (!p || p.val <= 0) return;
      var nuevo = formatea(p, p.val + sobreprecio(p.val));
      el.dataset.ctReal = txt;
      el.textContent = nuevo;
      el.dataset.ctInflado = nuevo;
      el.classList.add('ct-precio-teatro');
    });
    aplicando = false;
  }

  /* El precio cae: primero el número se pone ROJO y crece un instante, y AHÍ cambia al real.
     Amo vio el efecto y lo pidió así: "que por un segundo se ponga rojo y luego cambie". */
  function desinflar() {
    aplicando = true;
    var nodos = [].slice.call(document.querySelectorAll('.ct-precio-teatro'));
    nodos.forEach(function (el) { el.classList.add('ct-precio-avisa'); });
    setTimeout(function () {
      nodos.forEach(function (el) {
        if (el.dataset.ctReal) el.textContent = el.dataset.ctReal;
        el.classList.remove('ct-precio-teatro', 'ct-precio-avisa');
        el.classList.add('ct-precio-cae');
        delete el.dataset.ctInflado;
        delete el.dataset.ctReal;
        setTimeout(function () { el.classList.remove('ct-precio-cae'); }, 900);
      });
      aplicando = false;
    }, 400);
  }

  function init() {
    var reloj = document.querySelector('[id^="cd1028-"]');
    if (!reloj) return;
    var barra = reloj.closest('.cdbar-1028');
    var texto = barra ? barra.querySelector('[class*="cdbar-1028__text"]') : null;
    var T = window.ctTheatreTextos || {};

    var bH0 = reloj.querySelector('[data-h]');
    // El hueco de DÍAS puede no existir (depende del ajuste show_days del tema). Si falta, se crea
    // clonando el de horas: la etapa 3 cuenta días y sin esto se perdía el "3d" y se veía 00:29:31.
    var bD = reloj.querySelector('[data-d]');
    if (!bD && bH0) {
      var uH = bH0.nextElementSibling, sepH = uH ? uH.nextElementSibling : null;
      bD = bH0.cloneNode(true); bD.removeAttribute('data-h'); bD.setAttribute('data-d', '');
      var uD = uH ? uH.cloneNode(true) : null;
      if (uD) uD.textContent = (window.ctTheatreTextos && window.ctTheatreTextos.u_dias) || 'd';
      var sepD = sepH ? sepH.cloneNode(true) : null;
      bH0.parentNode.insertBefore(bD, bH0);
      if (uD) bH0.parentNode.insertBefore(uD, bH0);
      if (sepD) bH0.parentNode.insertBefore(sepD, bH0);
    }
    var bH = bH0;
    var bM = reloj.querySelector('[data-m]'), bS = reloj.querySelector('[data-s]');
    function grupo(b) {
      if (!b) return [];
      var u = b.nextElementSibling;                       // <span> de la unidad (d/h/m/s)
      var sep = u ? u.nextElementSibling : null;          // el ":" siguiente
      return [b, u, sep && sep.classList && sep.classList.contains('cdbar-1028__sep') ? sep : null];
    }
    function mostrar(g, on) { g.forEach(function (n) { if (n) n.style.display = on ? '' : 'none'; }); }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    // estado persistente: en qué etapa va este visitante
    var st;
    try { st = JSON.parse(localStorage.getItem(K)) || null; } catch (e) { st = null; }
    var ahora = Date.now();
    if (!st || !st.t1) {
      st = { t1: ahora + SEG_ETAPA1 * 1000 };
      st.t2 = st.t1 + MIN_ETAPA2 * 60000;
      st.t3 = st.t2 + DIAS_ETAPA3 * 86400000;
      localStorage.setItem(K, JSON.stringify(st));
    }
    etapa = ahora < st.t1 ? 1 : (ahora < st.t2 ? 2 : 3);

    if (etapa === 1) {
      if (texto) texto.textContent = T.baja || 'PRICE DROPS IN';
      inflar();
      var pend = null;
      obs = new MutationObserver(function () {
        if (aplicando || etapa !== 1) return;
        clearTimeout(pend);
        pend = setTimeout(inflar, 40);
      });
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
      ['change', 'click'].forEach(function (ev) {
        document.addEventListener(ev, function () { if (etapa === 1) setTimeout(inflar, 60); }, true);
      });
    } else if (texto) {
      texto.textContent = etapa === 2 ? (T.acaba || 'Offer ends in') : (T.ampliada || 'Offer extended — ends in');
    }

    function pinta() {
      var t = Date.now();
      if (etapa === 1 && t >= st.t1) {
        etapa = 2;
        if (obs) obs.disconnect();
        desinflar();
        if (texto) texto.textContent = T.acaba || 'Offer ends in';
      } else if (etapa === 2 && t >= st.t2) {
        etapa = 3;
        if (texto) texto.textContent = T.ampliada || 'Offer extended — ends in';
      } else if (etapa === 3 && t >= st.t3) {
        st.t3 = Date.now() + DIAS_ETAPA3 * 86400000;   // la oferta nunca acaba de verdad
        localStorage.setItem(K, JSON.stringify(st));
      }

      var fin = etapa === 1 ? st.t1 : (etapa === 2 ? st.t2 : st.t3);
      var s = Math.max(0, Math.floor((fin - t) / 1000));
      var dias = Math.floor(s / 86400), hor = Math.floor((s % 86400) / 3600);
      var min = Math.floor((s % 3600) / 60), seg = s % 60;

      // se enseña una unidad solo si el tiempo restante la USA. Determinista: depende de los
      // segundos que quedan, no de la etapa (antes dependía de la etapa y en algún borde se
      // colaba un "00m:19s" en la cuenta de 28 segundos).
      mostrar(grupo(bD), s >= 86400);
      mostrar(grupo(bH), s >= 3600);
      mostrar(grupo(bM), s >= 60);
      mostrar(grupo(bS), true);
      if (bD) bD.textContent = pad(dias);
      if (bH) bH.textContent = pad(hor);
      if (bM) bM.textContent = pad(min);
      if (bS) bS.textContent = pad(seg);
    }

    pinta();
    setInterval(pinta, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
